import { atom } from 'jotai';

import { ALL_AXES } from '@core';
import { UserGuide } from '@data';

import { selectedActiveAnalysisAtom } from '../swing/swings';

import { parametersAtom } from './uiNodes';

export const swingGuidesAtom = atom<UserGuide>();
export const selectedSwingGuideParameterAtom = atom<number | null>(null);

export const swingGuideTimeSeriesAtom = atom((get) => {
    const guides = get(swingGuidesAtom) ?? [];
    return new Map(guides.map((guide) => [guide.timeSeriesMeasurementId, guide] as const));
});

export const swingGuideAxesAtom = atom((get) => {
    const guides = get(swingGuidesAtom) ?? [];
    return new Map(guides.map((guide) => [guide.timeSeriesMeasurementId, guide.axes] as const));
});

export const swingGuideParametersAtom = atom((get) => {
    const parameters = get(parametersAtom) ?? [];
    const measurements = get(selectedActiveAnalysisAtom)?.data.analysis?.measurements ?? [];
    const axesByTimeSeriesId = get(swingGuideAxesAtom);
    const axesByTimeSeriesName = new Map(
        measurements.flatMap(({ measurement_id, measurement_name }) => {
            const axes = axesByTimeSeriesId.get(measurement_id);
            return axes ? [[measurement_name, axes] as const] : [];
        }),
    );

    return new Map(
        parameters.flatMap(({ parameter }) => {
            const axes = axesByTimeSeriesName.get(parameter.timeSeriesId ?? '');
            return axes?.some(
                (axis) =>
                    parameter.axis === ALL_AXES[axis.axis] &&
                    axis.parameters.some(({ pPosition }) => parameter.position === `p${pPosition}`),
            )
                ? [[parameter.smpId, true] as const]
                : [];
        }),
    );
});

export const swingGuideParametersByTimeSeriesIdAtom = atom((get) => {
    const guideParameters = get(swingGuideParametersAtom);
    const parameters = get(parametersAtom) ?? [];
    const entries: [string, number][] = parameters.flatMap(({ parameter }) =>
        parameter.timeSeriesId && guideParameters.has(parameter.smpId)
            ? [[parameter.timeSeriesId, parameter.smpId]]
            : [],
    );

    return Object.fromEntries(entries);
});
